export default __webpack_public_path__ + "static/media/flag-es-EC.ff32e967.png";